@if (device$ | async; as device) {
  <div class="d-flex align-items-center justify-content-between mb-2">
    <span>Tuning mode</span>
    <div class="btn-group" role="group">
      <input
        class="btn-check"
        type="radio"
        name="automaticTuningMode"
        id="automaticTuningMode"
        [checked]="tuningController.autoTuningEnabled"
        [value]="true"
        [disabled]="isFullAutotuningRunning"
        (click)="onSetAutoTuningEnabled(true)"
      />
      <label
        class="btn"
        [ngClass]="tuningController.autoTuningEnabled ? 'btn-secondary' : 'btn-outline-secondary'"
        for="automaticTuningMode"
        >Automatic</label
      >
      <input
        class="btn-check"
        type="radio"
        name="automaticTuningMode"
        id="manualTuningMode"
        [checked]="!tuningController.autoTuningEnabled"
        [value]="false"
        [disabled]="isFullAutotuningRunning"
        (click)="onSetAutoTuningEnabled(false)"
      />
      <label
        class="btn"
        [ngClass]="tuningController.autoTuningEnabled ? 'btn-outline-secondary' : 'btn-secondary'"
        for="manualTuningMode"
        >Manual</label
      >
    </div>
  </div>
  @if (tuningController.autoTuningEnabled) {
    <div>
      <div class="d-flex align-items-center mb-3">
        <div class="w-100">
          <app-full-auto-tuning-button
            [device]="device$ | async"
            (startFullAutoTuning)="onStartFullAutoTuning()"
            (stopFullAutoTuning)="onStopFullAutoTuning()"
          ></app-full-auto-tuning-button>
        </div>
        <button
          class="btn btn-outline-link rounded-0 border-top-0 border-end-0 border-bottom-0 btn-parameter-help text-body-secondary pt-3"
          type="button"
          tabindex="-1"
          title="Open description"
          (click)="onOpenFullAutoTuningDescription()"
        >
          <i class="bi-info-circle"></i>
        </button>
      </div>
      <app-parameter-form
        [parameters$]="tuningParameters$"
        [disableInputs]="isFullAutotuningRunning"
        (rangeInputChange)="onRangeInputChange($event)"
      >
      </app-parameter-form>
      <table
        class="table table-sm mb-0 mt-2"
        [ngClass]="{
          'opacity-50': isFullAutotuningRunning
        }"
      >
        <colgroup>
          <col style="width: 34%" />
          <col style="width: 64%" />
        </colgroup>
        @if (pidParameters$ | async; as parameters) {
          <tbody>
            <tr>
              <th scope="row">Kp</th>
              <td>{{ parameters[0].value | roundFloat: 6 }}</td>
            </tr>
            <tr>
              <th scope="row">Ki</th>
              <td>{{ parameters[1].value | roundFloat: 6 }}</td>
            </tr>
            <tr>
              <th scope="row">Int. limit</th>
              <td>{{ parameters[3].value }}</td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  } @else {
    <app-device-parameter-form
      [parameters$]="pidParameters$"
      [showApplyButton]="true"
      [showSubmit]="true"
      [disableInputs]="isFullAutotuningRunning"
      submitText="APPLY PID VALUES"
    >
    </app-device-parameter-form>
  }
}
